module.exports = __webpack_public_path__ + "img/personal_icon_selected.2d247f25.png";